import { ReferralDTO } from "@shaarp/common";
import { useTranslation } from "react-i18next";
import { DataTable } from "../data-table/data-table";
import { dataTableReferralsColumns } from "./data-table-referrals-columns";

export default function DataTableReferrals({
  referrals,
  isLoading = false,
}: {
  referrals: ReferralDTO[];
  isLoading?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <DataTable
      showFilter={false}
      data={referrals}
      columns={dataTableReferralsColumns()}
      isLoading={isLoading}
      emptyText={t("referrals.dataTable.empty")}
    />
  );
}
